(function () {
	// ====== CONFIG (edit these to suit) ======
	var LABEL = 'VIEW OTHER COMPETITIONS';
	var ITEMS = [
		{ target: '#product-media', text: 'Gallery' },
		{ target: '.shopify-section--specification', text: 'Details' },
		{ target: '.cc-faq', text: 'How it works' },
		{ target: '.custom-product-tab-container', text: 'Entry' },
		// { target: '.mobile-details button:nth-child(3)', text: 'Delivery' }
	];
	var BG = '#222222';
	// =========================================

	var maxMs = 8000, step = 50, waited = 0;
	function waitFor(sel, cb){
		var el = document.querySelector(sel);
		if (el) return cb(el);
		if (waited >= maxMs) return;
		waited += step; setTimeout(function(){ waitFor(sel, cb); }, step);
	}

	waitFor('.media-gallery__viewer .media-viewer__item:nth-child(1)', function(host){
		if (!host || document.getElementById('cro-img-overlay')) return;

		var navHTML = ITEMS.map(function(it, idx){
			return [
				'<li class="pillnav__item">',
				'<a class="pillnav__link' + (idx === 0 ? ' pillnav__link--active' : '') + '" data-target="' + it.target + '" href="#">',
				it.text,
				'</a>',
				'</li>'
			].join('');
		}).join('');

		var navWrapper = document.createElement('div');
		navWrapper.className = 'pillnav-wrap';
		navWrapper.style.position = 'absolute';
		navWrapper.innerHTML = [
			'<nav class="pillnav" aria-label="Section navigation">',
				'<ul class="pillnav__list" role="list">', navHTML, '</ul>',
			'</nav>'
		].join('');
		var pillNav = navWrapper.querySelector('.pillnav');

		var gallery = document.querySelector('.media-gallery__viewer .media-viewer__item:nth-child(1)');
		var galleryContainer = document.querySelector('.media-gallery__viewer');
		if(galleryContainer) {
			var oldWrap = galleryContainer.querySelector('.pillnav-wrap');
			if (oldWrap) {
				oldWrap.remove();
			}
			galleryContainer.appendChild(navWrapper);
		} else {
			host.innerHTML = '';
			host.appendChild(navWrapper);
		}
		
		if (gallery) {
			if (!gallery.querySelector('.feefo-logo-abs')) {
				var feefoImg = document.createElement('img');
				feefoImg.src = 'https://api.feefo.com/api/logo?merchantidentifier=the-giveaway-guys';
				feefoImg.alt = 'Feefo Reviews';
				feefoImg.className = 'feefo-logo-abs';
				gallery.appendChild(feefoImg);
			}
			var badgeAmount = null;
			var badgeAmountNumber = null;
			var titleElement = document.querySelector('.product_main_title_cash');
			if (titleElement) {
				var titleText = titleElement.textContent.trim();
				var titleLower = titleText.toLowerCase();
				if (titleLower.includes('fast friday')) {
					badgeAmountNumber = 'fastfriday';

				} else if (titleLower.includes('12 months')) {
					badgeAmountNumber = '12-months';

				} else {
					titleText = titleText.replace(/,/g, '');
					var match = titleText.match(/£(\d{3,6})/);
					if (match) {
						badgeAmount = match[1];
						badgeAmountNumber = parseInt(badgeAmount, 10) || 0;
					}
				}
			}
			function formatBadgeAmount(amount) {
				var num = parseInt(amount, 10);
				if (isNaN(num)) return null;
				return (num >= 1000) ? Math.floor(num / 1000) + 'k' : num.toString();
			}
			var shopifyFilesBaseUrl = 'https://cdn.shopify.com/s/files/1/0310/5698/6248/files/';
			var badgeUrl = null;
			if (badgeAmountNumber) {
				var badgeShorthand = (badgeAmountNumber === '12-months')
					? '12-months'
					: badgeAmountNumber;

				if (badgeShorthand) {
					if (badgeShorthand === 'fastfriday') {
						badgeUrl = shopifyFilesBaseUrl + '3.FastFriday-tgg-badge.png';
					} else {
						badgeUrl = shopifyFilesBaseUrl + badgeShorthand + '-tgg-badge.png';
					}
				}
			}
			if (badgeUrl && !gallery.querySelector('.badge-cash-abs')) {
				var badgeImg = document.createElement('img');
				badgeImg.src = badgeUrl;

				// ✅ Updated alt logic
				if (badgeAmountNumber === 'fastfriday') {
					badgeImg.alt = 'Fast Friday Badge';
				} else if (badgeAmountNumber === '12-months') {
					badgeImg.alt = '12 Months Badge';
				} else {
					badgeImg.alt = '£' + badgeAmount + ' Badge';
				}

				badgeImg.className = 'badge-cash-abs';
				gallery.appendChild(badgeImg);
			}
		}

		document.addEventListener('click', function(e) {
			var link = e.target.closest('.pillnav__link');
			if (link) {
				console.log('[pillnav debug] pillnav__link clicked:', link);
				e.preventDefault();
				var nav = link.closest('.pillnav');
				if (nav) {
					nav.querySelectorAll('.pillnav__link').forEach(function(l) {
						l.classList.remove('pillnav__link--active');
					});
				}
				link.classList.add('pillnav__link--active');
				var targetSel = link.getAttribute('data-target');
				console.log('[pillnav debug] data-target:', targetSel);
				if (targetSel) {
					var targetEl = document.querySelector(targetSel);
					console.log('[pillnav debug] target element:', targetEl);
					if (targetEl) {
						if (targetEl.tagName === 'BUTTON') {
							if (!targetEl.classList.contains('active')) {
								targetEl.click();
							}
						}
						function getOffsetTopRelativeToDocument(el) {
							var top = 0;
							while (el) {
								top += el.offsetTop;
								el = el.offsetParent;
							}
							return top;
						}
						var scrollTop = getOffsetTopRelativeToDocument(targetEl) - 120;
						console.log('[pillnav debug] scrollTo:', scrollTop);
						window.scrollTo({ top: scrollTop, behavior: 'smooth' });
					} else {
						console.warn('[pillnav debug] No element found for selector:', targetSel);
					}
				}
			}
		});

	});
})();

// Utility to wait for multiple selectors
function waitForAll(selectors, cb) {
	var found = selectors.map(function(sel) { return document.querySelector(sel); });
	if (found.every(Boolean)) return cb.apply(null, found);
	setTimeout(function() { waitForAll(selectors, cb); }, 50);
}

window.hashString = function (string) {
	if (typeof string === 'undefined') {
		return false;
	}
	let hash = 0, i, chr;
	if (string.length === 0) return hash;
	for (i = 0; i < string.length; i++) {
		chr = string.charCodeAt(i);
		hash = (hash << 5) - hash + chr;
		hash |= 0;
	}
	return hash;
};

window.countdown_timeout = window.countdown_timeout || {};

window.detectElement = (selector, callback) => {
	let selector_hash = hashString(selector);
	if (false === selector_hash) {
		return false;
	}
	if (typeof window.countdown_timeout[selector_hash] === 'undefined') {
		window.countdown_timeout[selector_hash] = null;
	}
	clearTimeout(window.countdown_timeout[selector_hash]);
	window.countdown_timeout[selector_hash] = setTimeout(() => {
		if (document.querySelectorAll(selector).length === 0) {
			window.detectElement(selector, callback);
			return false;
		} else {
			if (typeof callback === 'function') {
				callback();
			}
			return true;
		}
	}, 200);
};

(() => {

	const pillnav_clone = () => {

		const container_div       = document.createElement('div');
		const collection_existing = document.querySelector('.section--collection_bar');
		const collection_clone    = collection_existing.cloneNode(true);
		const pillnav_existing    = document.querySelector('.pillnav-wrap');
		const pillnav_clone       = pillnav_existing.cloneNode(true);
		const media_thumbs        = document.querySelector('.media-gallery .media-thumbs__item');

		container_div.classList.add('sticky-container');
		pillnav_clone.classList.add('pillnav-fixed');
		collection_existing.classList.add('collection-fixed');

		collection_existing.after(container_div);
		container_div.prepend(pillnav_clone);
		container_div.prepend(collection_existing);

		window.addEventListener('scroll', () => {
			if (!media_thumbs) {
				const gallery_viewer = document.querySelector('.media-gallery__viewer');
				if (!gallery_viewer) return;
				const scrolled_past = (gallery_viewer.getBoundingClientRect().bottom < 120);
				pillnav_clone.classList.toggle('active', scrolled_past);
				return;
			}
			const scrolled_past = (media_thumbs.getBoundingClientRect().y < 0);
			pillnav_clone.classList.toggle('active', scrolled_past);
		});

		const pillnav_links = pillnav_clone.querySelectorAll('.pillnav__link');

		let last_scroll_top = 0;

		const is_visible_observer = new IntersectionObserver(() => {

			let activeLink = null;
			const scroll_top = window.pageYOffset || document.documentElement.scrollTop;
			const scrolling_down = scroll_top > last_scroll_top;
			last_scroll_top = Math.max(0, scroll_top);

			pillnav_links.forEach((link) => {

				let targetSelector = link.getAttribute('data-target');
				if (targetSelector === '.mobile-details button:nth-child(1)') {
					targetSelector += ' + .accordion--content';
				}

				const target = document.querySelector(targetSelector);
				if (target) {
					const rect = target.getBoundingClientRect();

					if (scrolling_down) {
						if (rect.top <= window.innerHeight && rect.bottom > 0) {
							activeLink = link;
						}
					} else {
						if (rect.top <= window.innerHeight && rect.bottom > 0) {
							activeLink = link;
						}
						return;
					}
				}
			});

			pillnav_links.forEach((link) => {
				link.classList.remove('pillnav__link--active');
			});

			if (activeLink) {
				document.activeElement.blur();
				activeLink.classList.add('pillnav__link--active');
			}

		}, {
			rootMargin: '0px 0px 0px 0px',
			threshold: [0, 0.5, 1.0]
		});

		pillnav_links.forEach(link => {
			let targetSelector = link.getAttribute('data-target');

			if (targetSelector === '.mobile-details button:nth-child(1)') {
				targetSelector += ' + .accordion--content';
			}

			const target = document.querySelector(targetSelector);

			if (target) {
				is_visible_observer.observe(target);
			}
		});

	};

	if (!document.body.classList.contains('cro-tgg-21')) {

		document.body.classList.add('cro-tgg-21', 'cro-tgg-21--variant1');

		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.type = 'text/css';
		link.href = `//cro.sculpt.digital/tgg-cro/tgg-21/tgg-21.css`;

		document.head.appendChild(link);

		detectElement('.pillnav-wrap', pillnav_clone);

		document.addEventListener('click', (evt) => {

			const collection_bar = document.querySelector('.sticky-container .collection__bar');
			if (!collection_bar) return;
			if (!collection_bar.classList.contains('active') || evt.target.closest('.collection__bar')) {
				return;
			}

			collection_bar.querySelector('.collection_bar_trigger').click();

		});

	}

})();